import { Group, Stack } from "@mantine/core";
import CancelActionButton from "./CancelActionButton";
import DeleteActionButton from "./DeleteActionButton";
import SaveActionButton from "./SaveActionButton";

/**
 * @param {object} props
 * @param {boolean} [props.showDelete=false]
 * @param {boolean} [props.loading=false]
 * @param {() => void} [props.onCancel]
 * @param {() => void} [props.onDelete]
 * @param {import("react").ReactNode} [props.submitIcon]
 * @param {string} [props.submitText]
 */
export default function Actions({
	showDelete = false,
	loading = false,
	onCancel,
	onDelete,
	submitIcon,
	submitText,
}) {
	return (
		<Stack>
			{showDelete && <DeleteActionButton loading={loading} onClick={onDelete} />}
			<Group grow>
				<CancelActionButton loading={loading} onClick={onCancel} />
				<SaveActionButton
					loading={loading}
					submitIcon={submitIcon}
					submitText={submitText}
				/>
			</Group>
		</Stack>
	);
}
